"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EzbuyApp = void 0;

var _regex = require("../regex");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var EzbuyApp = /*#__PURE__*/function () {
  function EzbuyApp(ua, mobileCatalog) {
    var _this = this;

    _classCallCheck(this, EzbuyApp);

    _defineProperty(this, "ua", void 0);

    _defineProperty(this, "mobileCatalog", void 0);

    _defineProperty(this, "clientUAParams", {});

    _defineProperty(this, "isSupportLiveChat", function () {
      return _this.isInEzbuyApp && (_this.isIOS && _this.checkAppVersion(911) || _this.isAndroid && _this.checkAppVersion(914));
    });

    _defineProperty(this, "isSupportPaySuccess", function () {
      return _this.isInEzbuyApp && (_this.isIOS || _this.isAndroid && _this.checkAppVersion(201998300));
    });

    _defineProperty(this, "isSupportAftersaleLink", function () {
      return _this.isInEzbuyApp && (_this.isIOS && _this.checkAppVersion(960) || _this.isAndroid && _this.checkAppVersion(201895701));
    });

    _defineProperty(this, "primeBuyUsePrePay", function () {
      return _this.isInEzbuyApp && (_this.isAndroid && !_this.checkAppVersion(201895701) || _this.isIOS && !_this.checkAppVersion(958));
    });

    _defineProperty(this, "supportReminder", function () {
      return _this.isInEzbuyApp && (_this.isAndroid && _this.checkAppVersion(201896501) || _this.isIOS);
    });

    _defineProperty(this, "supportCombineLiveChat", function () {
      return _this.isInEzbuyApp && (_this.isIOS && _this.checkAppVersion(9250) || _this.isAndroid && _this.checkAppVersion(2021092500));
    });

    this.ua = ua;
    this.mobileCatalog = mobileCatalog;

    var result = _regex.userAgentRegExp.exec(ua);

    if (result !== null) {
      this.clientUAParams = result[1].split(";").reduce(function (pValue, cValue) {
        var arrs = cValue.split("/");

        if (arrs.length > 1) {
          pValue[arrs[0]] = arrs.slice(1).join("");
        }

        return pValue;
      }, {});
    }
  }

  _createClass(EzbuyApp, [{
    key: "checkAppVersion",
    value: function checkAppVersion(wishVersion) {
      var _this$clientUAParams;

      var currentAppVersion = (_this$clientUAParams = this.clientUAParams) === null || _this$clientUAParams === void 0 ? void 0 : _this$clientUAParams.AppVersion;

      if (!currentAppVersion) {
        return false;
      }

      var versionParts = currentAppVersion.split(".");

      if (versionParts.length === 1) {
        return parseInt(currentAppVersion, 10) >= wishVersion;
      }

      var numberStr = "".concat(versionParts[0], ".").concat(versionParts.slice(1).join(""), ";"); // wish version must be x.xx

      return parseFloat(numberStr) >= wishVersion;
    }
  }, {
    key: "isInEzbuyApp",
    get: function get() {
      var _this$clientUAParams2, _this$clientUAParams3;

      return ((_this$clientUAParams2 = this.clientUAParams) === null || _this$clientUAParams2 === void 0 ? void 0 : (_this$clientUAParams3 = _this$clientUAParams2.Type) === null || _this$clientUAParams3 === void 0 ? void 0 : _this$clientUAParams3.toLowerCase()) === "ezbuyapp";
    }
  }, {
    key: "language",
    get: function get() {
      var _this$clientUAParams4, _this$clientUAParams5, _this$clientUAParams6;

      return ((_this$clientUAParams4 = this.clientUAParams) === null || _this$clientUAParams4 === void 0 ? void 0 : (_this$clientUAParams5 = _this$clientUAParams4.Language) === null || _this$clientUAParams5 === void 0 ? void 0 : (_this$clientUAParams6 = _this$clientUAParams5.replace(/-hans$/i, "")) === null || _this$clientUAParams6 === void 0 ? void 0 : _this$clientUAParams6.toLowerCase()) || "en";
    }
  }, {
    key: "catalog",
    get: function get() {
      var _this$clientUAParams7, _this$clientUAParams8;

      return ((_this$clientUAParams7 = this.clientUAParams) === null || _this$clientUAParams7 === void 0 ? void 0 : (_this$clientUAParams8 = _this$clientUAParams7.Area) === null || _this$clientUAParams8 === void 0 ? void 0 : _this$clientUAParams8.toLowerCase()) || "";
    }
  }, {
    key: "isDiffrentArea",
    get: function get() {
      var _this$mobileCatalog;

      if (!this.isInEzbuyApp) {
        return false;
      }

      return !!this.catalog && ((_this$mobileCatalog = this.mobileCatalog) === null || _this$mobileCatalog === void 0 ? void 0 : _this$mobileCatalog.toLowerCase()) !== this.catalog;
    }
  }, {
    key: "isAndroid",
    get: function get() {
      var _this$ua, _this$ua2;

      return ((_this$ua = this.ua) === null || _this$ua === void 0 ? void 0 : _this$ua.indexOf("Android")) > -1 || ((_this$ua2 = this.ua) === null || _this$ua2 === void 0 ? void 0 : _this$ua2.indexOf("Adr")) > -1;
    }
  }, {
    key: "isIOS",
    get: function get() {
      var _this$ua3;

      return !!((_this$ua3 = this.ua) === null || _this$ua3 === void 0 ? void 0 : _this$ua3.match(_regex.iosRegExp));
    }
  }, {
    key: "statusbarHeight",
    get: function get() {
      var _this$clientUAParams9;

      return ((_this$clientUAParams9 = this.clientUAParams) === null || _this$clientUAParams9 === void 0 ? void 0 : _this$clientUAParams9.statusbarHeight) || "";
    }
  }]);

  return EzbuyApp;
}();

exports.EzbuyApp = EzbuyApp;